<template>
<div class="focused-panel">
  <div class="d-flex wellpad-toolbar">
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create wellpad" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select wellpad" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Move wellpad" :disabled="!wellFeatureSelected" :pressed.sync="translateEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Rotate wellpad" :disabled="!wellFeatureSelected" :pressed.sync="rotateEnabled" variant="primary">
      <icon scale=".6" name="circle-notch" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete wellpad" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers" variant="primary">
      <icon scale=".6" name="link" />
    </b-btn>

  </div>

  <b-modal v-model="showForm" no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header">
      <label>{{formTitle}}</label>
      <div v-if='editablePhase'>
        <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
          <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
        </div>

        <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
          <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
        </div>
      </div>
    </div>
    <div class="p-2">
      <div id='feature-locked-warning-1' v-if="!editablePhase">
        <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
      </div>
      <div id='feature-locked-warning' v-if="editablePhase && featureLock">
        <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
      </div>
      <b-form>
        <b-row>
          <b-col>
            <div id='pad-concept-id' v-if="wellFeature && wellFeature.get('concept_id')">
              <b-alert class='user-reminder' variant="info" show>Concept ID: {{wellFeature.get('concept_id')}}</b-alert>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Ident:" label-for="wellpadIdent">
              <b-form-input :state="identState" id="wellpadIdent" :disabled="featureLock" v-model="wellAttrs['ident']" placeholder="Enter Ident"></b-form-input>
              <b-form-invalid-feedback>
                Wellpad ident is not unique, change will be ignored
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Online date override:" label-for="onlineDate">
              <b-form-input id="onlineDate" :disabled="featureLock" v-model="online_date" type="date"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Acquire Pad Name:" label-for="wellpadAcquireName">
              <b-form-input id="wellpadAcquireName" :disabled="featureLock" v-model="wellAttrs['acquire_pad_name']" placeholder="Enter Acquire Pad Name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Number of Wells:" label-for="numWells">
              <b-form-input v-model="wellAttrs['numwells']" id="numWells" :disabled="featureLock" required type="number" :min="0" :max="8" placeholder="Enter well quantity"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Comment:" label-for="wellpadComment">
              <b-textarea id="wellpadComment" v-model="wellAttrs['comment']" rows="3"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-row v-if="state === 'CHECK' && this.wellAttrs['numwells'] != this.initialWellCount">
        <b-col>
          <div id='num wells-warning'>
            <b-alert class='user-reminder' variant="warning" show>You are about to make a change to the number of wells on this wellpad. Are you sure you wish to continue?</b-alert>
          </div>
        </b-col>
      </b-row>
    </div>

    <div slot="modal-footer" class="designatron-modal-footer">
      <b-row v-if="state === 'CHECK' && this.wellAttrs['numwells'] != this.initialWellCount">
        <b-col>
          <div role="group" class="btn-group">
            <b-btn size="sm" class="float-right" variant="primary" @click="resetNumWells">
              Cancel
            </b-btn>
            <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onSave">
              Save
            </b-btn>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <div v-if="isToolEnabled('update_from_survey') && !featureLock" id="update-survey-container">
            <b-btn size="sm" @click="surveyUpdate">
              Update from survey
            </b-btn>
          </div>
        </b-col>
        <b-col>
          <div role="group" class="btn-group">
            <b-btn size="sm" class="float-right" variant="primary" @click="close">
              Close
            </b-btn>
            <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onSaveCheck">
              Save
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</div>
</template>

<script>
import 'vue-awesome/icons/circle-notch'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/unlock'


import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import RotateFeatureInteraction from 'ol-rotate-feature'
import TranslateInteraction from 'ol/interaction/Translate'

export default {
  name: 'wellpad-editor',
  components: {},
  mixins: [FeatureEditorMixin],
  created() {
    this.rotateInteraction = null
    this.translateInteraction = null
  },
  data() {
    return {
      wellLayerName: 'v4:_wellpad',
      wellAttrs: {
        ident: '',
        numwells: 1,
        acquire_pad_name: '',
        comment: ''
      },
      online_date: null,
      hoverLock: false,
      lockable: true,
      schema: 'wellpad',
      state: 'DEFAULT',
      // geomType: 'Polygon',
      initialWellCount: null,
      numwells: 1,
      identState: null,
      initialIdent: null,
      addViaService: true
    }
  },
  methods: {
    beforeSaveCallback () {
      console.log('setting custom for modified features...')
      this.newFeatures.concat(this.modifiedFeatures).forEach(f => f.set('custom', true))
    },
    parseOverrides () {
      let overrides
      if (this.wellFeature && this.wellFeature.get('overrides')) {
        try {
          overrides = JSON.parse(this.wellFeature.get('overrides'))
        } catch (e) {
          console.log("ERROR: could not parse well overrides")
        }
      }

      if (overrides) {
        if (overrides.online_date) {
          this.online_date = overrides.online_date
        } else {
          this.online_date = null
        }
      } else {
        this.online_date = null
      }
    },
    packOverrides () {
      let overrides = {}
      if (this.wellFeature.get('overrides')) {
        try {
          overrides = JSON.parse(this.wellFeature.get('overrides'))
        } catch (e) {
          console.log("ERROR: could not parse well overrides")
        }
      }
      if (!overrides) {
        overrides = {}
      }

      if (this.online_date) {
        overrides['online_date'] = this.online_date
      } else {
        overrides['online_date'] = undefined
      }

      this.wellAttrs['overrides'] = JSON.stringify(overrides)
    },
    resetNumWells () {
      this.wellAttrs['numwells'] = this.initialWellCount
      this.state = 'DEFAULT'
    },
    onSaveCheck(evt) {
      this.state = 'CHECK'
      if (this.wellAttrs['numwells'] == this.initialWellCount) {
        this.state = 'DEFAULT'
        this.onOK(evt)
      }
    },
    onSave(evt) {
      this.initialWellCount = this.wellAttrs['numwells']
      this.state = 'DEFAULT'
      this.onOK(evt)
    },
    close(evt) {
      this.initialWellCount = null
      this.wellFeature = null
      this.showForm = false
      this.state = 'DEFAULT'
      this.onCancel()
    },
    surveyUpdate() {
      this.updateFeatureFromSurvey()
      this.close()
    }
  },
  watch: {
    showForm (val) {
      if (val) {
        this.parseOverrides()
      }
    },
    wellAttrs: {
      handler(val) {
        if (!this.initialWellCount) {
          this.initialWellCount = val.numwells
        }

        if (!this.initialIdent) {
          this.initialIdent = val.ident
        }
        else if (this.initialIdent !== val.ident) {
          let me = this
          this.validateIdent(val.ident)
        } else {
          this.identState = null
        }
      },
      deep: true
    },
    rotateEnabled(val) {

      if (val) {
        this.translateEnabled = false
        if (this.rotateInteraction) {
          this.$mapService.map.removeInteraction(this.rotateInteraction)
          this.rotateInteraction = null
        }
        this.rotateInteraction = new RotateFeatureInteraction({
          features: this.selectInteraction.getFeatures()
        })

        this.$mapService.map.addInteraction(this.rotateInteraction)
        this.rotateInteraction.on('rotateend', this.editGeom, this)
        this.rotateInteraction.on('rotatestart', this.beforeEditGeom, this)
      } else {
        this.$mapService.map.removeInteraction(this.rotateInteraction)
        this.rotateInteraction.un('rotateend', this.editGeom, this)
        this.rotateInteraction.on('rotatestart', this.beforeEditGeom, this)
        this.rotateInteraction = null
      }
    },
    translateEnabled(val) {

      if (val) {
        this.rotateEnabled = false
        if (this.translateInteraction) {
          this.$mapService.map.removeInteraction(this.translateInteraction)
          this.translateInteraction = null
        }
        this.translateInteraction = new TranslateInteraction({
          features: this.selectInteraction.getFeatures()
        })

        this.$mapService.map.addInteraction(this.translateInteraction)
        this.translateInteraction.on('translateend', this.editGeom, this)
        this.translateInteraction.on('translatestart', this.beforeEditGeom, this)
      } else {
        this.$mapService.map.removeInteraction(this.translateInteraction)
        this.translateInteraction.un('translateend', this.editGeom, this)
        this.translateInteraction.on('translatestart', this.beforeEditGeom, this)
        this.translateInteraction = null
      }
    },
    online_date(val) {
      this.packOverrides()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/WellPadEditor.vue